// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"64aaa958","453":"97ef7d99","455":"5614254d","977":"2b1afe56"}[chunkId] + ".chunk.js";
};